export const cardTypesConstants = {
  GET_CARDTYPES_REQUEST: "GET_CARDTYPES_REQUEST",
  GET_CARDTYPES_SUCCESS: "GET_CARDTYPES_SUCCESS",
  GET_CARDTYPES_FAILURE: "GET_CARDTYPES_FAILURE",
  GET_CARDTYPES_RESET: "GET_CARDTYPES_RESET",

  VIEW_CARDTYPE_REQUEST: "VIEW_CARDTYPE_REQUEST",
  VIEW_CARDTYPE_SUCCESS: "VIEW_CARDTYPE_SUCCESS",
  VIEW_CARDTYPE_FAILURE: "VIEW_CARDTYPE_FAILURE",
  VIEW_CARDTYPE_RESET: "VIEW_CARDTYPE_RESET",

  ADD_CARDTYPE_REQUEST: "ADD_CARDTYPE_REQUEST",
  ADD_CARDTYPE_SUCCESS: "ADD_CARDTYPE_SUCCESS",
  ADD_CARDTYPE_FAILURE: "ADD_CARDTYPE_FAILURE",
  ADD_CARDTYPE_RESET: "ADD_CARDTYPE_RESET",

  EDIT_CARDTYPE_REQUEST: "EDIT_CARDTYPE_REQUEST",
  EDIT_CARDTYPE_SUCCESS: "EDIT_CARDTYPE_SUCCESS",
  EDIT_CARDTYPE_FAILURE: "EDIT_CARDTYPE_FAILURE",
};
